import { useNavigate } from 'react-router-dom';
import { useAuthStore } from 'core/store/authStore';
import { ROUTES } from 'core/router/routes';

/**
 * Pill toggle that lets a provider switch between Runner and Customer views
 * without permanently changing their account role.
 * Only renders for users whose actual role is 'provider'.
 */
export default function RoleSwitcher() {
  const { user, activeView, setActiveView } = useAuthStore();
  const navigate = useNavigate();

  if (user?.role !== 'provider') return null;

  const isCustomerView = activeView === 'customer';

  const handleSwitch = () => {
    if (isCustomerView) {
      setActiveView(null);
      navigate(ROUTES.PROVIDER.DASHBOARD);
    } else {
      setActiveView('customer');
      navigate(ROUTES.CUSTOMER.DASHBOARD);
    }
  };

  return (
    <button
      type="button"
      onClick={handleSwitch}
      title={isCustomerView ? 'Switch back to Runner mode' : 'Switch to Customer mode'}
      className="hidden sm:flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-full border transition-all border-primary/30 bg-primary/5 text-primary hover:bg-primary/10 hover:border-primary/50"
    >
      <span
        className="material-symbols-outlined text-[15px]"
        style={{ fontVariationSettings: '"FILL" 1' }}
      >
        {isCustomerView ? 'local_shipping' : 'directions_run'}
      </span>
      {isCustomerView ? 'Switch to Runner mode' : 'Switch to Customer mode'}
    </button>
  );
}
